import React from 'react'
import PropTypes from 'prop-types'

const date = new Date();

const Footer = props => {
	const { timeout } = props;
	return(
	    <footer id="footer" style={timeout ? {display: 'none'} : {}}>
	        <p className="copyright">&copy; {date.getFullYear()} Leonil Omayan </p>
	    </footer>
	);
}
Footer.propTypes = {
    timeout: PropTypes.bool
}

export default Footer
